/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { BrandColors, Typography } from '@blend/enterprise-components';
import { RouterStates } from '../../../definitions/RouterStates';
import { NotaryAPI } from '../../../api/notary/types';
import { usePermissions } from '../../../hooks/usePermissions';
import { NotaryPopoverMenu } from './NotaryPopoverMenu';
import { NavLinkButton } from './NavLinkButton';
import blendLogoWhite from './blend-logo-white-h.svg';
import { getConfig } from '@utils/configs';

export const styles = StyleSheet.create({
  wrapper: {
    ...Typography.Roboto,
    fontWeight: Typography.MEDIUM,
    backgroundColor: BrandColors.NIGHT_90,
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    padding: 20,
  },
  logoWrapper: {
    display: 'block',
    width: '50%',
  },
  navButtonsWrapper: {
    marginTop: 64,
  },
});

export namespace NavigationSidebar {
  export interface Props {}
}
export const NavigationSidebar: React.FC<NavigationSidebar.Props> = ({}) => {
  const permissions = usePermissions();

  const notaryNavLinks: { display: string; iconType: string; route: string }[] = [
    {
      display: 'notarizations',
      iconType: 'calendar_today',
      route: permissions?.includes(NotaryAPI.BSRPermissions.BSRViewRoomList)
        ? RouterStates.ROOMS
        : RouterStates.ROOM_ASSIGNMENTS,
    },
    {
      display: 'journal',
      iconType: 'format_list_bulleted',
      route: RouterStates.JOURNAL,
    },
  ];

  if (permissions.includes(NotaryAPI.BSRPermissions.BSRAdmin)) {
    notaryNavLinks.push({
      display: 'notaries',
      iconType: 'person',
      route: `${getConfig().blendBridge.url}/notaries`,
    });
  }

  return (
    <div className={css(styles.wrapper)} data-it="NavigationSidebar">
      <div>
        <div className={css(styles.logoWrapper)}>
          <img src={blendLogoWhite} alt="blend-logo" />
        </div>
        <div className={css(styles.navButtonsWrapper)}>
          {notaryNavLinks.map(notaryNavLink => (
            <NavLinkButton
              data-it="NavLinkButton"
              key={notaryNavLink.display}
              display={notaryNavLink.display}
              iconType={notaryNavLink.iconType}
              route={notaryNavLink.route}
            />
          ))}
        </div>
      </div>
      <NotaryPopoverMenu />
    </div>
  );
};
